import { render, staticRenderFns } from "./sifreSifirlamaMenu.vue?vue&type=template&id=52ef283c&scoped=true"
import script from "./sifreSifirlamaMenu.vue?vue&type=script&lang=js"
export * from "./sifreSifirlamaMenu.vue?vue&type=script&lang=js"
import style0 from "./sifreSifirlamaMenu.vue?vue&type=style&index=0&id=52ef283c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef283c",
  null
  
)

export default component.exports